module.exports = __webpack_public_path__ + "media/images/emblems/Merzligen-coat_of_arms-8b13c67c45809b8078a7ef87187c6af7.svg";